import React, { useEffect, useState } from 'react'
import { SurfaceCard, ListPageShell, EmptyState, ActionIconButton } from '../../Components/Ui'
import ReactPlaceholder from 'react-placeholder/lib'
import Controllers from '../../Api/Controllers'
import Helpers from '../../Components/Helpers/Helpers'
import { Link, useParams } from 'react-router-dom'
import { FormCustom, TextArea } from '../../Components/Form/Form'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'

const avatarFallback = (e) => {
    e.currentTarget.style.display = 'none'
    if (e.currentTarget.nextSibling) e.currentTarget.nextSibling.style.display = 'inline-flex'
}

const btnPrimary = {
    borderRadius: 12,
    fontWeight: 700,
    minHeight: 42,
    padding: '0 18px',
    background: '#201030',
    color: '#fff',
    border: 'none',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8
}

const VideoHistory = _ => {
    const [readyCategory, setReadyCategory] = useState(false)
    const [readyVideos, setReadyVideos] = useState(false)
    const [videos, setVideos] = useState([])
    const [categories, setCategories] = useState([])
    const [formFilter, setFormFilter] = useState({
        p_id_category: '',
        p_filter_text: ''
    })
    const [localSearch, setLocalSearch] = useState('')
    const [row, setRow] = useState({
        p_description_comment: '',
    })
    const [loadSubmit, setLoadSubmit] = useState(false)
    const [reloadComments, setReloadComments] = useState(false)

    const store = useSelector(res => res)

    const [readyVideo, setReadyVideo] = useState(false)
    const [video, setVideo] = useState({})

    const { tokenVideo } = useParams()
    const [hasToken, setHasToken] = useState(tokenVideo !== undefined)

    useEffect(() => {
        setHasToken(tokenVideo !== undefined)
    }, [tokenVideo])

    const [videosRelated, setVideosRelated] = useState([])
    useEffect(() => {
        if (tokenVideo && hasToken) {
            Promise.all([
                Controllers.video.get_video_token({
                    p_token_video: tokenVideo
                }),
                Controllers.video.get_video_related({
                    p_token_video: tokenVideo
                })
            ]).then(res => {
                setRow({ ...row, p_id_video: res[0].data?.id_video })
                setVideo(res[0].data)
                setVideosRelated(res[1].data)
                setReadyVideo(true)
            })
        }
    }, [tokenVideo, hasToken])

    const [comments, setComments] = useState([])
    useEffect(() => {
        if (reloadComments || hasToken) {
            Controllers.comment.get_comment_video({
                p_token_video: tokenVideo
            }).then(res => {
                setComments(res.data)
                setReloadComments(false)
            })
        }
    }, [tokenVideo, reloadComments, hasToken])

    useEffect(() => {
        if (!readyVideos && !hasToken) {
            Controllers.course.get_course_public(formFilter).then(res => {
                setVideos(res.data)
                setReadyVideos(true)
            })
        }
    }, [readyVideos, formFilter, hasToken])

    useEffect(() => {
        Controllers.category.get_category().then(res => {
            setCategories([
                { id_category: '', name_category: 'Todas' },
                ...res.data,
            ])
            setReadyCategory(true)
        })
    }, [])

    const handleSubmitComment = ({ data }) => {
        setLoadSubmit(true)
        Controllers.comment.comment_video_insert_update(data).then(res => {
            Helpers.toast.construct({ ...res, toast })
            setRow({ ...row, p_description_comment: '' })
            setReloadComments(true)
            setLoadSubmit(false)
        })
    }

    const applySearch = () => {
        setHasToken(false)
        setFormFilter({ ...formFilter, p_filter_text: localSearch })
        setReadyVideos(false)
    }

    return (
        <ListPageShell
            eyebrow="Super Papelera — Capacitación"
            title={hasToken ? (video?.name_video || 'Video') : 'Buscador de Videos'}
            subtitle={hasToken ? (video?.name_course || 'Detalle del curso') : 'Explora cursos por departamento y busca material.'}
            badge="Videos"
            onSearch={!hasToken ? applySearch : undefined}
            filters={!hasToken ? [
                {
                    label: 'Departamento',
                    control: (
                        <select
                            value={formFilter.p_id_category}
                            disabled={!readyCategory}
                            onChange={e => setFormFilter({ ...formFilter, p_id_category: e.target.value })}
                        >
                            {categories.map(j => (
                                <option key={String(j.id_category)} value={j.id_category}>{j.name_category}</option>
                            ))}
                        </select>
                    )
                },
                {
                    label: 'Buscar',
                    control: (
                        <input
                            type="search"
                            placeholder="Buscar curso…"
                            value={localSearch}
                            onChange={e => setLocalSearch(e.target.value)}
                            onKeyDown={e => { if (e.key === 'Enter') applySearch() }}
                        />
                    )
                }
            ] : []}
        >
            {hasToken ? (
                video?.id_video || !readyVideo ? (
                    <ReactPlaceholder ready={readyVideo} rows={20} showLoadingAnimation>
                        <div className="form-row">
                            <div className="col-12 mb-3" style={{ padding: '8px 4px' }}>
                                <h6 style={{ margin: 0, color: '#201030', fontWeight: 800 }}>
                                    Curso: {video.name_course}
                                </h6>
                                <small className="sp-comment-meta">{video.description_course}</small>
                            </div>
                            <div className="col-12 col-md-8 mb-3">
                                {parseInt(video?.has_video) === 1 && video?.file_video ? (
                                    <video controls width="100%" style={{ maxHeight: 400, borderRadius: 16, marginBottom: 16 }}>
                                        <source type="video/mp4" src={Helpers.config.resourcesUrl({ url: video.file_video })} />
                                    </video>
                                ) : null}
                                <SurfaceCard title={video.name_video}>
                                    <p style={{ color: '#4B5563', fontSize: '0.9rem' }}>{video.description_video}</p>
                                    <div className="mb-3">
                                        <small className="sp-comment-meta">
                                            {video.name_category} · {video.date_created}
                                        </small>
                                    </div>
                                    {video.additional?.length > 0 ? (
                                        <div className="mb-3">
                                            <h6 style={{ color: '#201030', fontWeight: 700 }}>Material Adicional</h6>
                                            {React.Children.toArray(video.additional.map(a => (
                                                <div className="d-flex mb-2" style={{ gap: 10 }}>
                                                    <a target="_blank" rel="noreferrer" href={Helpers.config.resourcesUrl({ url: a.file_add })}>
                                                        <ActionIconButton tone="primary" icon="fa fa-file" />
                                                    </a>
                                                    <div className="d-flex flex-column">
                                                        <strong style={{ fontSize: '0.88rem', color: '#201030' }}>{a.name_add}</strong>
                                                        <span style={{ fontSize: '0.82rem', color: '#6B7280' }}>{a.description_add}</span>
                                                    </div>
                                                </div>
                                            )))}
                                        </div>
                                    ) : null}

                                    <SurfaceCard title="Tu comentario">
                                        <div className="d-flex align-items-center mb-3" style={{ gap: 10 }}>
                                            <img
                                                src={store.session.file_photo_user}
                                                alt=""
                                                width="36"
                                                height="36"
                                                style={{ borderRadius: 999, objectFit: 'cover' }}
                                                onError={avatarFallback}
                                            />
                                            <span style={{ fontWeight: 600, color: '#201030', fontSize: '0.88rem' }}>
                                                {store.session.full_name || 'Tú'}
                                            </span>
                                        </div>
                                        <FormCustom className="mb-3" viewSubmit={false} dataSubmit={row} onSubmit={handleSubmitComment}>
                                            <TextArea
                                                text="Escribe tu comentario"
                                                classNameParent="col-12"
                                                rows="5"
                                                required
                                                value={row.p_description_comment}
                                                onChange={e => setRow({ ...row, p_description_comment: e.currentTarget.value })}
                                            />
                                            <div className="col-12 mt-3">
                                                <button type="submit" style={btnPrimary}>
                                                    {loadSubmit
                                                        ? <i className="fa fa-circle-notch fa-spin" />
                                                        : <><i className="fa fa-paper-plane" />Enviar</>}
                                                </button>
                                            </div>
                                        </FormCustom>
                                    </SurfaceCard>

                                    {React.Children.toArray(comments.map(c => (
                                        <div className="sp-comment-card">
                                            <div className="sp-comment-author">
                                                <div style={{ position: 'relative' }}>
                                                    <img
                                                        src={Helpers.config.resourcesUrl({ url: c.file_photo_cust })}
                                                        width="36"
                                                        height="36"
                                                        alt=""
                                                        style={{ borderRadius: 999, objectFit: 'cover' }}
                                                        onError={avatarFallback}
                                                    />
                                                    <span className="sp-avatar-fallback" style={{ display: 'none', width: 36, height: 36 }}>
                                                        <i className="fa fa-user" />
                                                    </span>
                                                </div>
                                                <div>
                                                    <strong>{c.full_name_cust}</strong>
                                                </div>
                                            </div>
                                            <p style={{ margin: 0, color: '#374151', fontSize: '0.9rem' }}>{c.description_comment}</p>
                                        </div>
                                    )))}
                                </SurfaceCard>
                            </div>
                            <div className="col-12 col-md-4">
                                <SurfaceCard title="Videos Relacionados">
                                    {React.Children.toArray(videosRelated.map(v => (
                                        <Link
                                            className="sp-feed-card"
                                            style={{ padding: 12 }}
                                            onClick={_ => {
                                                setHasToken(true)
                                                setReadyVideo(false)
                                            }}
                                            to={Helpers.config.convertUrl({ url: '/buscador-de-videos/' + v.token_video })}
                                        >
                                            <img
                                                src={Helpers.config.resourcesUrl({ url: v.file_images })}
                                                width="48"
                                                height="48"
                                                alt=""
                                                style={{ borderRadius: 10, objectFit: 'cover', flexShrink: 0 }}
                                            />
                                            <div style={{ minWidth: 0, flex: 1 }}>
                                                <h6 style={{ fontSize: '0.86rem' }}>{v.name_video}</h6>
                                                <small className="sp-comment-meta">{v.date_created}</small>
                                            </div>
                                        </Link>
                                    )))}
                                </SurfaceCard>
                            </div>
                        </div>
                    </ReactPlaceholder>
                ) : (
                    <EmptyState
                        icon="fa fa-video"
                        title="Sin información"
                        text="No hay información para mostrar."
                    />
                )
            ) : (
                <ReactPlaceholder ready={readyVideos} rows={20} showLoadingAnimation>
                    {videos.length > 0 ? (
                        <div className="form-row" style={{ padding: '8px 4px' }}>
                            {React.Children.toArray(videos.map(v => (
                                <section className="col-12 col-sm-6 col-md-3 mb-4">
                                    {v.categories.includes(store.session.id_category) ? (
                                        <Link
                                            onClick={_ => {
                                                setHasToken(true)
                                                setReadyVideo(false)
                                            }}
                                            to={Helpers.config.convertUrl({ url: '/buscador-de-videos/' + v.token_video })}
                                            style={{ textDecoration: 'none' }}
                                        >
                                            <div style={{
                                                borderRadius: 16,
                                                border: '1px solid #E5E7EB',
                                                overflow: 'hidden',
                                                background: '#fff'
                                            }}>
                                                <img
                                                    src={Helpers.config.resourcesUrl({ url: v.file_images })}
                                                    width="100%"
                                                    height="150"
                                                    alt=""
                                                    style={{ objectFit: 'cover', display: 'block' }}
                                                />
                                                <div style={{ padding: 12 }}>
                                                    <h6 style={{ margin: 0, color: '#201030', fontWeight: 700, textAlign: 'center', fontSize: '0.88rem' }}>
                                                        {v.name_course}
                                                    </h6>
                                                </div>
                                            </div>
                                        </Link>
                                    ) : (
                                        <div style={{
                                            opacity: 0.55,
                                            cursor: 'not-allowed',
                                            borderRadius: 16,
                                            border: '1px solid #E5E7EB',
                                            overflow: 'hidden',
                                            background: '#fff'
                                        }}>
                                            <img
                                                src={Helpers.config.resourcesUrl({ url: v.file_images })}
                                                width="100%"
                                                height="150"
                                                alt=""
                                                style={{ objectFit: 'cover', display: 'block' }}
                                            />
                                            <div style={{
                                                padding: 12,
                                                minHeight: 70,
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                <h6 style={{ margin: 0, color: '#201030', fontWeight: 700, textAlign: 'center', fontSize: '0.88rem' }}>
                                                    {v.name_course}
                                                </h6>
                                                <strong style={{ color: '#C41022', fontSize: '0.75rem', marginTop: 4 }}>
                                                    No pertenece a tu área
                                                </strong>
                                            </div>
                                        </div>
                                    )}
                                </section>
                            )))}
                        </div>
                    ) : (
                        <EmptyState
                            icon="fa fa-video"
                            title="Sin cursos"
                            text="No hay información para mostrar."
                        />
                    )}
                </ReactPlaceholder>
            )}
        </ListPageShell>
    )
}

export default VideoHistory
